export * from './menu/actions';
export * from './products/actions';
export * from './merchant/actions';
export * from './menuModal/actions';
export * from './events/actions';
export * from './newMenu/actions';
export * from './categories/actions';
export * from './variations/actions';
export * from './productAddons/actions';
export * from './tags/actions';
export * from './scroll/actions';



// WEBPACK FOOTER //
// ./src/store/actions.js